import { useCallback } from 'react';
import { useQuery } from 'urql';
import { QueryVariables } from '../types';
import { getSocialAnalyticsNetworks } from '../graphql';
import { GetSocialAnalyticsNetworksQuery } from '../../../../gql/social/graphql';

interface UseNetworksDataProps {
  clientId: string;
  tab: string;
  queryVariables: QueryVariables;
}

export const useNetworksData = ({
  clientId,
  tab,
  queryVariables,
}: UseNetworksDataProps): {
  fetching: boolean;
  handleRefresh: () => void;
  data: GetSocialAnalyticsNetworksQuery | undefined;
} => {
  const [{ data: networksData, fetching: fetchingPosts }, refetchPosts] = useQuery({
    query: getSocialAnalyticsNetworks,
    variables: {
      clientId: clientId || '',
      startDate: queryVariables.startDate || '',
      endDate: queryVariables.endDate || '',
      postTypes: queryVariables.postTypes || [],
      includeEstimates: queryVariables.includeEstimates || false,
      postDateIntervalEnabled: queryVariables.postDateIntervalEnabled || false,
      networks: queryVariables.networks || [],
      projectIds: queryVariables.projectIds,
      groupIds: queryVariables.groupIds,
      memberIds: queryVariables.memberIds,
      segments: queryVariables.segments,
    },
    pause: !clientId || tab !== 'networks',
  });

  const handleRefresh = useCallback(() => {
    if (tab === 'networks') {
      refetchPosts({ requestPolicy: 'network-only' });
    }
  }, [refetchPosts, tab]);

  return {
    fetching: fetchingPosts,
    handleRefresh,
    data: networksData,
  };
};
